import { GetterTree } from "vuex";

import { SystemSettingsState } from '@/models/SystemSettingsState';

export const getters: GetterTree<SystemSettingsState, {}> = {
    userManualEnabled(state: SystemSettingsState): boolean {
        return state.userManualVideoEnabled;
    },
    userHelpButtonEnabled(state: SystemSettingsState): boolean {
        return state.userHelpButtonEnabled;
    }
};
